export default {
    bar: 'bar-chart-bar',
    value: 'bar-chart-bar-value',
    description: 'bar-chart-bar-description',
    tooltip: 'bar-chart-bar-tooltip',
};
//# sourceMappingURL=dataHooks.js.map